import { render } from "./InlineConfirmation.vue?vue&type=template&id=360b41c0&scoped=true"
import script from "./InlineConfirmation.vue?vue&type=script&lang=js"
export * from "./InlineConfirmation.vue?vue&type=script&lang=js"

import "./InlineConfirmation.vue?vue&type=style&index=0&id=360b41c0&scoped=true&lang=css"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-360b41c0"]])

export default __exports__